import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/community.js';
import FaqEvent from '../../components/FaqEvent';
import axios from 'axios';

function CommunityPortal() {

    const [communityWebPortalInfo, setCommunityWebPortalInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const getPortalInfo = async () => {
            try {
                const apiBaseUrl = process.env.REACT_APP_API_URL;

                if (!apiBaseUrl) {
                    throw new Error('API base URL is not configured.');
                }

                const res = await axios.get(`${apiBaseUrl}/real-fm/api/v1/community-portal/find-all`);
                setCommunityWebPortalInfo(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error(err);
                setError('Community portal content is temporarily unavailable.');
            } finally {
                setLoading(false);
            }
        }
        getPortalInfo();
    },[])

    useEffect(() => {
        document.title = 'Community Portal | REAL FM';
    }, []);

    const renderContent = () => {
        if (loading) {
            return (
                <div className="portal-state portal-loading">
                    <div className="portal-state-card">
                        <div className="portal-spinner" />
                        <h4>Loading community portal</h4>
                        <p>Fetching the latest portal details and community features.</p>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="portal-state portal-empty">
                    <div className="portal-state-card">
                        <h4>Community portal unavailable</h4>
                        <p>{error}</p>
                    </div>
                </div>
            );
        }

        if (!communityWebPortalInfo.length) {
            return (
                <div className="portal-state portal-empty">
                    <div className="portal-state-card">
                        <h4>No portal content available yet</h4>
                        <p>The community portal is still being prepared. Check back again soon.</p>
                    </div>
                </div>
            );
        }

        return communityWebPortalInfo.map((info, i) => (
            <article className="portal-card" key={i}>
                <div className="course-desc">
                    <h4>{info.communityTagLine}</h4>
                </div>
                <div className="course-feature">
                    <Row>
                        <Col sm="12">
                            <div
                                className="portal-copy"
                                dangerouslySetInnerHTML={{ __html: info.communityDesc }}
                            />
                        </Col>
                    </Row>
                </div>
            </article>
        ));
    }

    return (
        <div className="main-wrapper course-details-page" >

            {/* Header 2 */}
            <HeaderTwo />

            {/* Breadcroumb */}
            <BreadcrumbBox title="Community Web Portal" />

            <Styles>
                <section className="course-details-area community-portal-area">
                    <Container>
                        <div className="community-portal-header">
                            <span className="section-kicker">Community Web Portal</span>
                            <h3>Everything your community needs in one place</h3>
                            <p>Access portal updates, service information, and community features from a single hub.</p>
                        </div>

                        <div className="card custom-card community-portal-card">
                            {renderContent()}
                        </div>

                        <div className="community-features-block">
                            <FaqEvent />
                        </div>
                    </Container>
            </section>
        </Styles>

            {/* Footer 2 */}
            <FooterTwo />

        </div>
    )
}

export default CommunityPortal